import analytics from '../index';

async function trackFluencyEvents(fieldId, fieldName, fluency, timeSpent, keypresses) {
  const fluencyPayload = {
    field_id:   fieldId,
    field_name: fieldName,
    time_spent: timeSpent,
    fluency,
    keypresses,
  };

  await analytics.track('fluency', fluencyPayload);
}

function handleFocusEvent(e) {
  const { target } = e;

  target.dataset.keypresses = '0';
  target.dataset.startingTime = Date.now().toString();
}

function handleKeypressEvent(e) {
  const { target } = e;

  target.dataset.keypresses = (parseInt(target.dataset.keypresses, 10) + 1).toString();
}

function handleBlurEvent(e) {
  const { target } = e;

  if (!target.dataset.startingTime || !target.dataset.keypresses) {
    return;
  }

  const fieldId = target.id;
  const fieldName = target.name;
  const startingTime = parseInt(target.dataset.startingTime, 10);
  const keypresses = parseInt(target.dataset.keypresses, 10);
  const endingTime = Date.now();
  const timeDiff = (endingTime - startingTime) / 1000;
  const fluency = keypresses / timeDiff;
  const roundedFluency = fluency.toFixed(3);

  trackFluencyEvents(fieldId, fieldName, roundedFluency, timeDiff, keypresses);

  delete target.dataset.keypresses;
  delete target.dataset.startingTime;
}

function addFluencyEventListeners() {
  const inputs = document.getElementsByTagName('input');

  for (let i = 0; i < inputs.length; i += 1) {
    inputs[i].addEventListener('focus', handleFocusEvent);
    inputs[i].addEventListener('blur', handleBlurEvent);
    inputs[i].addEventListener('keydown', handleKeypressEvent);
  }
}

function removeFluencyEventListeners() {
  const inputs = document.getElementsByTagName('input');

  for (let i = 0; i < inputs.length; i += 1) {
    inputs[i].removeEventListener('focus', handleFocusEvent);
    inputs[i].removeEventListener('blur', handleBlurEvent);
    inputs[i].removeEventListener('keydown', handleKeypressEvent);
  }
}

export {
  addFluencyEventListeners,
  removeFluencyEventListeners,
  handleBlurEvent,
  handleFocusEvent,
  handleKeypressEvent,
  trackFluencyEvents,
};
